/**
 * A nav entry is active on its own route AND on anything nested under it, so a detail page
 * (`/merchants/:id`, `/products/add`) keeps its parent highlighted. Two guards matter:
 *   • `/` is exact-only — Dashboard's path is `/`, and a bare `startsWith` would light it
 *     up on every route.
 *   • the `/` separator is required, so `/orders` never matches `/custom-orders`.
 */
export const isPathActive = (pathname: string, path: string) =>
  path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`)
